/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDocumentCheck = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 2h10.414L20 7.586V13h-2V9h-5V4H6v16h6v2H4zm11 3.414V7h1.586zm5.269 9.904 1.462 1.364-5.398 5.784-3.064-3.284 1.462-1.364 1.602 1.716z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDocumentCheck as DocumentCheck };
